import React from "react";
import ReactApexChart from "react-apexcharts";

interface IndustryData {
    industry: string;
    count: number;
}

interface Props {
    industryDistribution: IndustryData[];
}

const IndustryDistributionTreeMap: React.FC<Props> = ({
    industryDistribution,
}) => {
    const fillColor = "#D549CD";
    const data = (industryDistribution || []).map((entry) => ({
        x: entry.industry,
        y: entry.count,
        fillColor,
    }));

    const options = {
        chart: {
            type: "treemap" as const,
        },
        title: {
            align: "center" as const,
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: "18px",
                color: "#263238",
            },
        },
        legend: {
            show: true,
            position: "bottom" as const,
        },
    };

    return (
        <div>
            <ReactApexChart
                options={options}
                series={[{ data }]}
                type="treemap"
                height={350}
            />
        </div>
    );
};

export default IndustryDistributionTreeMap;
